<template>
  <div>
    <div class="main">
      <DataTablePage
        resource="book.json"
        title="表簿管理"
        dialogSize="tiny"
        :relation="false"
        :toolbar="book.toolbar"
        :operation="book.operation"
        :autoIndex="false"
        :tableFullList="book.tableFullList"
        :tableInitList="book.tableInitList"
        :filterFullList="book.filterFullList"
        :filterInitList="book.filterInitList"
        :columns="book.columns"
        >
      </DataTablePage>
    </div>
    <el-dialog
      v-model="showMap"
      :modal-append-to-body="false">
      <div class="mapBox">
        <div id="map"></div>
        <div id="searchMap">
          <dl>
            <dt>请输入关键字：</dt>
            <dd><el-input v-model="mapSearchVal" placeholder="输入户号/户名/地址搜索" @blur="mapSearchEvent"></el-input></dd>
          </dl>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :title="waterUserTitle"
      :size="'large'"
      v-model="showWaterUser"
      :modal-append-to-body="false"
      >
      <DataTablePage
        resource="waterMeter.json"
        dialogSize="tiny"
        :relation="false"
        :toolbar="waterMeter.toolbar"
        :autoIndex="false"
        :tableFullList="waterMeter.tableFullList"
        :tableInitList="waterMeter.tableInitList"
        :filterFullList="waterMeter.filterFullList"
        :filterInitList="waterMeter.filterInitList"
        :columns="waterMeter.columns"
        :fullTableWidth="true"
        :requestData="requestData"
        >
      </DataTablePage>
    </el-dialog>
  </div>
</template>

<script>
import DataTablePage from '@/containers/DataTablePage'
import { toolbarExport } from '@/containers/DataTablePage/toolbar'
import { fetch } from '@/utils/api'
import markerPic from './marker.png'
import { expire } from '@/utils/auth'
// import AMapUI from 'AMapUI'

export default {
  name: 'meterReadingBook',
  components: {
    DataTablePage
  },
  data () {
    const _this = this
    return {
      book: {
        toolbar: [toolbarExport],
        tableInitList: ['bookNum', 'Last_Water', 'Now_Water', 'Now_Meter', 'total'],
        tableFullList: ['bookNum', 'Last_Water', 'Now_Water', 'Now_Meter', 'total'],
        filterInitList: ['bookNum'],
        filterFullList: ['bookNum'],
        operation: [{
          label: '查看地图',
          func (data) {
            _this.showMap = true
            _this.getCoordinate(data.bookNum)
          }
        }, {
          label: '查看用水户',
          func (data) {
            _this.showWaterUser = true
            _this.waterUserTitle = `【${data.bookNum}】 用水户信息`
            _this.requestData = { bookNum: data.bookNum }
          }
        }],
        columns: {
          bookNum: {
            label: '区本号',
            filter: {
              type: 'input'
            }
          },
          Last_Water: {
            label: '上期用水量',
            sort: true
          },
          Now_Water: {
            label: '本期用水量',
            sort: true
          },
          Now_Meter: {
            label: '本期已抄户数',
            sort: true
          },
          total: {
            label: '总户数',
            sort: true
          }
        }
      },
      waterMeter: {
        toolbar: [toolbarExport],
        tableInitList: ['bookNum', 'customNum', 'customName', 'phone', 'quality', 'address', 'date', 'code', 'outerCode', 'caliber', 'range', 'status'],
        tableFullList: ['bookNum', 'customNum', 'customName', 'phone', 'quality', 'address', 'date', 'code', 'outerCode', 'caliber', 'range', 'status'],
        filterInitList: ['customNum', 'quality', 'date'],
        filterFullList: ['customNum', 'quality', 'date'],
        columns: {
          bookNum: {
            label: '区本号'
            // width: 85
          },
          customNum: {
            label: '户号',
            // width: 72,
            filter: {
              type: 'input',
              like: true
            }
          },
          customName: {
            label: '户名'
            // width: 80
          },
          phone: {
            label: '手机'
            // width: 150
          },
          quality: {
            label: '用水性质',
            type: 'input',
            // width: 100,
            filter: {
              type: 'input'
            }
          },
          address: {
            label: '地址'
          },
          date: {
            label: '换表日期',
            sort: true,
            // width: 170,
            minLength: 20,
            type: 'time',
            dateType: 'YYYY-MM-DD HH:mm:ss',
            filter: {
              type: 'daterange'
            }
          },
          code: {
            label: '条形码'
            // width: 85
          },
          outerCode: {
            label: '行码'
            // width: 70
          },
          caliber: {
            label: '口径'
            // width: 70
          },
          range: {
            label: '量程'
            // width: 70
          },
          status: {
            label: '服务状态'
          }
        }
      },
      waterUserTitle: '用水户信息',
      showWaterUser: false,
      showMap: false,
      requestData: {},
      map: {},
      cluster: null,
      markers: [],
      mapSearchVal: '',
      mapData: []
      // AMapManager,
    }
  },
  mounted () {
    let result = expire()
    if (!result) {
      this.$router.push('/login')
    }
  },
  methods: {
    // 获取显示地图信息
    getCoordinate (id) {
      fetch({
        method: 'get',
        url: 'map.json',
        params: {
          bookNum: id
        }
      }).then(data => {
        this.mapData = data.data
        this.addMap(data)
      })
    },
    // 初始化地图
    addMap (data) {
      this.markers = []
      this.map = new AMap.Map('map', {
        resizeEnable: true,
        zoom: 13,
        center: [data.data[0][0].pointLon, data.data[0][0].pointLat]
      })
      this.addMarkers(data.data)
    },
    // 添加点聚合
    addMarkers (data) {
      const _this = this
      let allData = []
      this.markers = []
      data.forEach((val, key) => {
        val.forEach(v => {
          this.markers.push(new AMap.Marker({
            position: [v.pointLon, v.pointLat],
            icon: markerPic,
            offset: new AMap.Pixel(-15, -15)
          }).on('click', () => {
            _this.showInfoWindow([v], [v.pointLon, v.pointLat])
          }))
          allData.push(v)
        })
      })
      this.map.plugin(['AMap.MarkerClusterer'], () => {
        this.cluster = new AMap.MarkerClusterer(this.map, this.markers, {
          gridSize: 35,
          averageCenter: true
        })
        AMap.event.addListener(this.cluster, 'click', (e) => {
          let cr = e.target
          let mp = cr.getMap()
          let mpZoom = mp.getZoom()
          if (mpZoom >= 18) {
            let mks = e.markers
            console.log(mks)
            if (mks !== undefined && mks !== null && mks.length > 0) {
              let result = []
              allData.forEach(val => {
                if (mks.some(v => { return Number(val.pointLat) === v.G.position.lat && Number(val.pointLon) === v.G.position.lng })) {
                  result.push(val)
                }
              })
              this.showInfoWindow(result, e.lnglat)
            }
          }
        })
      })
    },
    // 显示信息窗口
    showInfoWindow (data, position) {
      let content = ''
      data.forEach(val => {
        content += `<tr>
          <td>${val.usercode}</td>
          <td>${val.username}</td>
          <td>${val.address}</td>
        </tr>`
      })
      let html = `<div style="max-height:170px;overflow:auto;"><table class="table table-bordered table-striped text-nowrap" style="margin-bottom:0;"><tr><th>户号</th><th>户名</th><th>地址</th></tr>${content}</table></div>`
      let infoWindow = new AMap.InfoWindow({
        autoMove: true,
        closeWhenClickMap: true
      })
      infoWindow.setContent(html)
      infoWindow.open(this.map, position)
    },
    // 地图搜索事件
    mapSearchEvent () {
      let data = Array.from(...this.mapData)
      let result = []
      window.setTimeout(() => {
        if (this.mapSearchVal) {
          result = data.filter(val => {
            return val.usercode.indexOf(this.mapSearchVal) !== -1 || val.username.indexOf(this.mapSearchVal) !== -1 || val.address.indexOf(this.mapSearchVal) !== -1
          })
          if (result.length > 0) {
            console.log([result])
            this.cluster.clearMarkers()
            this.addMarkers([result])
          } else {
            this.cluster.clearMarkers()
          }
        }
      }, 1000)
    }
  }
}
</script>

<style lang="sass" scoped="scoped">
.mapBox
  position: relative
#searchMap
  position: absolute
  top: 0
  left: 0
  background: #fff
  padding: 10px
#map  
  width: 100%
  height: 400px
</style>



// WEBPACK FOOTER //
// index.vue?fdd5f134